export default "__VITE_PUBLIC_ASSET__3f55c28e__"